import { useAuth } from '../context/AuthContext';
import { ContainerView } from '../components/ContainerView';

export default function DashboardPage() {
  const { profile } = useAuth();
  if (!profile) return null;
  return (
    <div>
      <h1 className="mb-4 text-xl font-semibold">My Files</h1>
      <ContainerView ownerId={profile.id} folderId={null} />
    </div>
  );
}
